import { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMessage } from "@/lib/api";

export const PdfButton = ({ url, testId }) => {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get(url, { responseType: "blob" });
      const name = (r.headers["content-disposition"] || "").match(/filename="(.+)"/)?.[1] || "safe-start.pdf";
      const link = document.createElement("a");
      link.href = URL.createObjectURL(r.data);
      link.download = name;
      link.click();
      setTimeout(() => URL.revokeObjectURL(link.href), 2000);
    } catch (e) {
      toast.error(errMessage(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button type="button" variant="outline" data-testid={testId} onClick={download} disabled={busy} className="h-10 px-3">
      {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <FileDown className="mr-2 h-4 w-4" />} PDF
    </Button>
  );
};
